import { render, staticRenderFns } from "./fallberakning.vue?vue&type=template&id=025f2d0a&shadow"
import script from "./fallberakning.vue?vue&type=script&lang=js&shadow"
export * from "./fallberakning.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./fallberakning.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports